import React, { Component } from 'react';
import { connect } from 'react-redux';
import { getFacebookProfileData } from '../../store/ducks/facebook';
import { loginWithFacebook } from '../../store/ducks/user';

export default function(WrappedComponent) {
  class WithFacebookLogin extends Component {
    state = { pending: false, error: null }

    login = async () => {
      this.setState({ pending: true, error: null });

      let error = null;
      try {
        await this.props.login(); //eslint-disable-line react/prop-types
      } catch (err) {
        if (err.message.indexOf('Provider user is not an iFit user') === -1) {
          error = err;
        }
        throw err;
      } finally {
        this.setState({ pending: false, error: error ? error.message : null });
      }
    }

    clearErrors = () => {
      this.setState({ error: null });
    }

    render() {
      return (
        <WrappedComponent
          { ...this.props }
          facebookLogin= {{
            login: this.login,
            clearErrors: this.clearErrors,
            pending: this.state.pending,
            error: this.state.error
          }}
        />
      );
    }
  }

  return connect(
    null,
    dispatch => ({
      login: async () => {
        const fbProfileData = await dispatch(getFacebookProfileData());
        await dispatch(loginWithFacebook(fbProfileData.value.accessToken));
      }
    })
  )(WithFacebookLogin);
};
